import api from './api';

export interface ClientContact {
  id?: string;
  name: string;
  email: string;
  phone?: string;
  role?: string;
}

export interface Client {
  id: string;
  name: string;
  billingAddress: {
    street: string;
    city: string;
    state?: string;
    postalCode: string;
    country: string;
  };
  accountDetails?: {
    accountNumber?: string;
    sortCode?: string;
    iban?: string;
    swift?: string;
  };
  chargeRate: number;
  currency: string;
  workingHoursPerDay?: number;
  customerType?: 'Contract' | 'Time and Materials' | 'T&M';
  contractStartDate?: string;
  contractEndDate?: string;
  contacts: ClientContact[];
  timesheetSubmissionDate?: number; // Deprecated
  timesheetDates?: string[]; // Array of ISO date strings for timesheet submission dates
  invoiceSubmissionDate?: number; // Deprecated
  invoiceDates?: string[]; // Array of ISO date strings for invoice generation dates
  createdAt: string;
  updatedAt: string;
}

export interface CreateClientData {
  name: string;
  billingAddress: {
    street: string;
    city: string;
    state?: string;
    postalCode: string;
    country: string;
  };
  accountDetails?: {
    accountNumber?: string;
    sortCode?: string;
    iban?: string;
    swift?: string;
  };
  chargeRate: number;
  currency: string;
  workingHoursPerDay?: number;
  contacts: ClientContact[];
  timesheetSubmissionDate?: number; // Deprecated
  timesheetDates?: string[] | Date[]; // Array of ISO date strings (from API) or Date objects (in form)
  invoiceSubmissionDate?: number; // Deprecated
  invoiceDates?: string[] | Date[]; // Array of ISO date strings (from API) or Date objects (in form)
}

export const clientsApi = {
  getAll: async (): Promise<Client[]> => {
    const response = await api.get('/clients');
    return response.data.data;
  },

  getById: async (id: string): Promise<Client> => {
    const response = await api.get(`/clients/${id}`);
    return response.data.data;
  },

  create: async (data: CreateClientData): Promise<Client> => {
    const response = await api.post('/clients', data);
    return response.data.data;
  },

  update: async (id: string, data: Partial<CreateClientData>): Promise<Client> => {
    const response = await api.put(`/clients/${id}`, data);
    return response.data.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/clients/${id}`);
  },
};

